const MAX_PAGES = 40;
const PAGE_STEP = { '96': 96, '100': 100 };

const plural = (n) => (n === 1 ? 'product' : 'products');

function setCount(grid, shown) {
  const el = document.querySelector('[data-hd-count]');
  if (!el) return;
  const total = parseInt(grid.dataset.total || '0', 10);
  el.textContent =
    total && shown < total
      ? `Showing 1–${shown} of ${total} products`
      : `${shown} ${plural(shown)}`;
}

function absorb(grid, html, limit) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const items = doc.querySelectorAll('[data-hd-autoload] > li');
  if (!items.length) return { added: 0, next: null };

  const frag = document.createDocumentFragment();
  let added = 0;
  items.forEach((li) => {
    if (limit == null || grid.children.length + added < limit) {
      frag.appendChild(li);
      added += 1;
    }
  });
  grid.appendChild(frag);

  const nextGrid = doc.querySelector('[data-hd-autoload]');
  return { added, next: nextGrid ? nextGrid.dataset.next || null : null };
}

async function autoload(grid) {
  const targetRaw = grid.dataset.target;
  if (!targetRaw) return;

  const isAll = targetRaw === 'all';
  const step = PAGE_STEP[targetRaw] || Infinity;
  let next = grid.dataset.next;
  if (!next) return;

  const status = document.querySelector('[data-hd-autoload-status]');
  const wrap = document.querySelector('[data-hd-loadmore-wrap]');
  const button = document.querySelector('[data-hd-loadmore]');
  const pagination = document.querySelector('[data-hd-pagination]');

  if (pagination) pagination.remove();

  const announce = (text) => {
    if (!status) return;
    status.hidden = !text;
    status.textContent = text;
  };

  async function fill(limit) {
    let pages = 0;
    while (next && pages < MAX_PAGES && (limit == null || grid.children.length < limit)) {
      pages += 1;
      announce(`Loading more products (${grid.children.length} so far)…`);

      let html;
      try {
        const res = await fetch(next, { headers: { 'X-Requested-With': 'fetch' } });
        if (!res.ok) throw new Error(String(res.status));
        html = await res.text();
      } catch {
        announce('Could not load more products. Please reload the page.');
        if (wrap) wrap.hidden = true;
        return false;
      }

      const result = absorb(grid, html, limit);
      next = result.next;
      if (!result.added) break;
    }
    return true;
  }

  const ok = await fill(isAll ? null : step);
  if (!ok) return;

  setCount(grid, grid.children.length);
  announce('');

  if (next && !isAll && wrap && button) {
    wrap.hidden = false;
    button.addEventListener('click', async () => {
      button.disabled = true;
      button.textContent = 'Loading…';
      const more = await fill(grid.children.length + step);
      setCount(grid, grid.children.length);
      announce('');
      if (!more || !next) {
        wrap.hidden = true;
      } else {
        button.disabled = false;
        button.textContent = 'Load more products';
      }
    });
  } else if (wrap) {
    wrap.hidden = true;
  }
}

document.querySelectorAll('[data-hd-autoload]').forEach((grid) => {
  if (grid instanceof HTMLElement && grid.dataset.target) autoload(grid);
});
